var en={

    'common':{
        'service':'service',
        'serviceStatus':'status',
    }
}
export default en


// WEBPACK FOOTER //
// ./src/assets/lang/en.js